import { render, staticRenderFns } from "./PreDashboard.vue?vue&type=template&id=3c834c7f&scoped=true"
import script from "./PreDashboard.vue?vue&type=script&lang=js"
export * from "./PreDashboard.vue?vue&type=script&lang=js"
import style0 from "./PreDashboard.vue?vue&type=style&index=0&id=3c834c7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c834c7f",
  null
  
)

export default component.exports